import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  CircularProgress,
  IconButton,
  TextField,
  Collapse,
  TablePagination,
  Grid,
  Button,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import CardHeadMenu from "../../Card/CardHeadMenu/CardHeadMenu";
import configServ from "../../../services/config";
import { useSelector } from "react-redux";
import AddIcon from "@mui/icons-material/Add";
import DownloadSalesCancelExcel from "../../Download/DownloadSalesCancelExcel";
import RotateLeftOutlinedIcon from "@mui/icons-material/RotateLeftOutlined";
import LoaderNew from "../../Loader/LoaderNew";
const SalesCancelReportTable = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [expandedRows, setExpandedRows] = useState([]);
  const { company_id, companyName, user_id, is_admin } = useSelector(
    (state) => state.GlobalVariables
  );
  // Fetch data from API
  const fetchData = async (query = "") => {
    try {
      setLoading(true);
      const result = await configServ.getCancelOrdersReports({
        company_id: company_id,
        order_no: query, // Send search query to the backend
      });
      if (result.success) {
        setData(result.data);
        setFilteredData(result.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Handle Search
  const handleSearch = async (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    await fetchData(query); // Fetch filtered data from backend
  };

  // Handle Row Expansion
  const toggleRowExpansion = (id) => {
    setExpandedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  // Pagination
  const handleChangePage = (_, newPage) => {
    setCurrentPage(newPage);
  };

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(0);
  };

  const paginatedData = filteredData.slice(
    currentPage * rowsPerPage,
    currentPage * rowsPerPage + rowsPerPage
  );

  return (
    <>
      <CardHeadMenu
        prefix={"Na"}
        suffix={"Na"}
        title={"Sales Cancel Report"}
        showCreate={false}
      />
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        spacing={2}
        className="px-4 py-2"
      >
        <Grid
          item
          xs={12}
          md={6}
          container
          alignItems="center"
          // justifyContent="space-between"
          gap={2}
        >
          <Typography variant="h6">
            Total Cancel Orders: {filteredData.length}
          </Typography>
          <Button
            variant="contained"
            color="primary"
            startIcon={
              loading ? (
                <CircularProgress size={24} sx={{ color: "white" }} />
              ) : (
                <DownloadIcon />
              )
            }
            onClick={() => DownloadSalesCancelExcel(filteredData, companyName)} // Ensure this function is implemented
          >
           {
            loading ? "": "Excel"
           }
          </Button>
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            label="Search by Order No"
            variant="outlined"
            size="small"
            fullWidth
            value={searchQuery}
            onChange={handleSearch}
            InputProps={{
              endAdornment: searchQuery && (
                <IconButton
                  onClick={() => {
                    setSearchQuery("");
                    fetchData(""); // Reset the data by fetching without a query
                  }}
                >
                  ✖️
                </IconButton>
              ),
            }}
          />
        </Grid>
      </Grid>

      <TableContainer component={Paper} className="rounded-lg shadow-md">
        <Table>
          <TableHead>
            <TableRow style={{ backgroundColor: "#4cb5f5" }}>
              <TableCell style={{ color: "white" }}>S.No</TableCell>
              <TableCell style={{ color: "white" }}>Order No</TableCell>
              <TableCell style={{ color: "white" }}>Party Name</TableCell>
              <TableCell style={{ color: "white" }}>Order Date</TableCell>
              <TableCell style={{ color: "white" }}>Total Amount</TableCell>
              <TableCell style={{ color: "white" }}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  <LoaderNew />
                </TableCell>
              </TableRow>
            ) : paginatedData.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6} align="center" style={{ color: "red" }}>
                  No Data Found
                </TableCell>
              </TableRow>
            ) : (
              paginatedData.map((order, index) => (
                <React.Fragment key={order.id}>
                  <TableRow
                    style={{
                      backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff",
                    }}
                  >
                    <TableCell>
                      {index + 1 + currentPage * rowsPerPage}
                    </TableCell>
                    <TableCell>{order.order_no}</TableCell>
                    <TableCell>{order.partyname}</TableCell>
                    <TableCell>{order.order_date}</TableCell>
                    <TableCell>{order.total_amount}</TableCell>
                    <TableCell>
                      <IconButton
                        onClick={() => toggleRowExpansion(order.id)}
                        size="small"
                      >
                        {expandedRows.includes(order.id) ? (
                          <KeyboardArrowUp />
                        ) : (
                          <AddIcon />
                        )}
                      </IconButton>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      colSpan={6}
                      style={{ paddingBottom: 0, paddingTop: 0 }}
                    >
                      <Collapse
                        in={expandedRows.includes(order.id)}
                        timeout="auto"
                        unmountOnExit
                      >
                        <div className="p-4">
                          <Typography variant="subtitle1">
                            Order Items:
                          </Typography>
                          <Table size="small">
                            <TableHead>
                              <TableRow style={{ backgroundColor: "#4cb5f5" }}>
                                <TableCell style={{ color: "white" }}>
                                  S.No.
                                </TableCell>
                                <TableCell style={{ color: "white" }}>
                                  Item Name
                                </TableCell>
                                <TableCell style={{ color: "white" }}>
                                  Quantity
                                </TableCell>
                                <TableCell style={{ color: "white" }}>
                                  Rate
                                </TableCell>
                                <TableCell style={{ color: "white" }}>
                                  Amount
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {order.items.map((item, index) => (
                                <TableRow
                                  key={item.id}
                                  style={{
                                    backgroundColor:
                                      index % 2 === 0 ? "#f9f9f9" : "#ffffff",
                                  }}
                                >
                                  <TableCell>{index + 1}</TableCell>
                                  <TableCell>{item.itemname}</TableCell>
                                  <TableCell>{item.qty}</TableCell>
                                  <TableCell>{item.rate}</TableCell>
                                  <TableCell>{item.amount}</TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </div>
                      </Collapse>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        rowsPerPageOptions={[20, 50, 100, 200, 500]}
        component="div"
        count={filteredData.length}
        rowsPerPage={rowsPerPage}
        page={currentPage}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  );
};

export default SalesCancelReportTable;
